{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/BRADEN",
	"name": "BRADEN",
	"language": "nl-BE",
	"status": "active",
	"publisher": "Corilus NV",
	"title": "Bradenschaal",
	"purpose": "Schat het risico op doorligwonden in",
	"description": "De totaalscore op deze zes items varieert tussen 6 en 23. Hoe hoger de score, hoe lager het decubitusrisico. Patiënten met een score lager dan 17 worden als risicopatiënt beschouwd in het ontwikkelen van decubitus.",
	"item": [
		{
			"linkId": "10200",
			"text": "Waarneming van pijn en ongemak",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "horizontal"
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "10201",
						"display": "Totaal verstoord"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "10202",
						"display": "Zeer verstoord"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				},
				{
					"valueCoding": {
						"code": "10203",
						"display": "Licht verstoord"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 3
						}
					]
				},
				{
					"valueCoding": {
						"code": "10204",
						"display": "Geen stoornis"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 4
						}
					]
				}
			],
			"item": [
				{
					"linkId": "10200_helpText",
					"text": "Het vermogen om zinvol te reageren op ongemak veroorzaakt door druk.",
					"_text": {
						"extension": [
							{
								"url": "http://hl7.org/fhir/StructureDefinition/rendering-xhtml",
								"valueString": "Het vermogen om zinvol te reageren op ongemak veroorzaakt door druk.<br/><br/>- <b>Totaal verstoord</b>: Reageert niet op pijnprikkels (kreunt niet, vertrekt geen spier, graait niet) tengevolge van verlaagd bewustzijn of sedatie - OF - beperkt vermogen om pijn te voelen over het grootste deel van het oppervlak van het lichaam.<br/><br/>- <b>Zeer verstoord</b>: Reageert enkel op pijnprikkels, kan ongemak enkel uiten door te kreunen of door rusteloosheid OF heeft een zintuiglijke belemmering die het vermogen beperkt om pijn en ongemak te voelen over de helft van het lichaam.<br/><br/>- <b>Licht verstoord</b>: Reageert op mondelinge bevelen maar kan niet altijd ongemak of de behoefte uiten om verlegd of gedraaid te worden OF heeft een zekere zintuiglijke belemmering die het vermogen beperkt om pijn of ongemak te voelen in 1 of 2 extremiteiten.<br/><br/>- <b>Geen stoornis</b>: Reageert op mondelinge bevelen. Heeft geen zintuiglijk tekort dat het vermogen beperkt om pijn of ongemak te uiten."
							}
						]
					},
					"type": "display",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "help",
										"display": "Help-Button"
									}
								],
								"text": "Help-Button"
							}
						}
					]
				}
			]
		},
		{
			"linkId": "10300",
			"text": "Vochtigheid huid",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "horizontal"
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "10301",
						"display": "Altijd vochtig"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "10302",
						"display": "Meestal vochtig"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				},
				{
					"valueCoding": {
						"code": "10303",
						"display": "Soms vochtig"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 3
						}
					]
				},
				{
					"valueCoding": {
						"code": "10304",
						"display": "Zelden vochtig"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 4
						}
					]
				}
			],
			"item": [
				{
					"linkId": "10300_helpText",
					"text": "De mate van vochtigheid waaraan de huid wordt blootgesteld.",
					"_text": {
						"extension": [
							{
								"url": "http://hl7.org/fhir/StructureDefinition/rendering-xhtml",
								"valueString": "De mate van vochtigheid waaraan de huid wordt blootgesteld.<br/><br/>- <b>Altijd vochtig</b>: Door perspiratie, urine etc. wordt de huid bijna constant vochtig gehouden. Telkens wanneer de patiënt wordt verplaatst of gedraaid, wordt vocht vastgesteld.<br/><br/>- <b>Meestal vochtig</b>: De huid is vaak, doch niet altijd vochtig. Het beddengoed (b.v. steeklaken, onderleggers) moet meerdere malen per dag worden vervangen.<br/><br/>- <b>Soms vochtig</b>: De huid is af en toe vochtig, waardoor het beddengoed ongeveer één keer per dag extra verwisseld moet worden.<br/><br/>- <b>Zelden vochtig</b>: De huid is meestal droog, het beddengoed moet enkel op de gebruikelijke tijdstippen worden verwisseld."
							}
						]
					},
					"type": "display",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "help",
										"display": "Help-Button"
									}
								],
								"text": "Help-Button"
							}
						}
					]
				}
			]
		},
		{
			"linkId": "10400",
			"text": "Activiteit",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "horizontal"
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "10401",
						"display": "Bed-gebonden"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "10402",
						"display": "Stoel-gebonden"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				},
				{
					"valueCoding": {
						"code": "10403",
						"display": "Loopt af en toe"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 3
						}
					]
				},
				{
					"valueCoding": {
						"code": "10404",
						"display": "Loopt vaak rond"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 4
						}
					]
				}
			],
			"item": [
				{
					"linkId": "10400_helpText",
					"text": "De mate van fysieke activiteit.",
					"_text": {
						"extension": [
							{
								"url": "http://hl7.org/fhir/StructureDefinition/rendering-xhtml",
								"valueString": "De mate van fysieke activiteit.<br/><br/>- <b>Bed-gebonden</b>: Is 24 uur per dag in bed.<br/><br/>- <b>Stoel-gebonden</b>: Vermogen om te lopen is ernstig beperkt of niet aanwezig. Kan het eigen gewicht niet dragen en/of moet in stoel of rolstoel worden geholpen.<br/><br/>- <b>Loopt af en toe</b>: Loopt af en toe overdag, maar over zeer korte afstanden, met of zonder hulp. Brengt een groot gedeelte van de dag in bed of stoel door.<br/><br/>- <b>Loopt vaak rond</b>: Wandelt minstens twee maal per dag buiten de kamer rond en binnen de kamer minstens één maal per twee uur tijdens de dag."
							}
						]
					},
					"type": "display",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "help",
										"display": "Help-Button"
									}
								],
								"text": "Help-Button"
							}
						}
					]
				}
			]
		},
		{
			"linkId": "10500",
			"text": "Mobiliteit",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "horizontal"
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "10501",
						"display": "Volledig immobiel"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "10502",
						"display": "Zeer beperkt"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				},
				{
					"valueCoding": {
						"code": "10503",
						"display": "Licht beperkt"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 3
						}
					]
				},
				{
					"valueCoding": {
						"code": "10504",
						"display": "Geen beperkingen"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 4
						}
					]
				}
			],
			"item": [
				{
					"linkId": "10500_helpText",
					"text": "Het vermogen om de eigen lichaamshouding te veranderen en te beheersen.",
					"_text": {
						"extension": [
							{
								"url": "http://hl7.org/fhir/StructureDefinition/rendering-xhtml",
								"valueString": "Het vermogen om de eigen lichaamshouding te veranderen en te beheersen.<br/><br/>- <b>Volledig immobiel</b>: Kan zonder hulp in de houding van zijn lichaam of ledematen, zelfs geen lichte veranderingen brengen.<br/><br/>- <b>Zeer beperkt</b>: Is beperkt in staat lichte veranderingen in de houding van zijn lichaam of extremiteiten aan te brengen, maar is niet in staat om regelmatig of grote veranderingen onafhankelijk uit te voeren.<br/><br/>- <b>Licht beperkt</b>: Kan zelfstandig en regelmatig lichte veranderingen aanbrengen in de houding van zijn lichaam of extremiteiten.<br/><br/>- <b>Geen beperkingen</b>: Kan zelfstandig regelmatig en grote veranderingen aanbrengen in de houding. heeft daarbij geen hulp nodig."
							}
						]
					},
					"type": "display",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "help",
										"display": "Help-Button"
									}
								],
								"text": "Help-Button"
							}
						}
					]
				}
			]
		},
		{
			"linkId": "10600",
			"text": "Voeding",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "horizontal"
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "10601",
						"display": "Onvoldoende"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "10602",
						"display": "Waarschijnlijk ontoereikend"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				},
				{
					"valueCoding": {
						"code": "10603",
						"display": "Toereikend"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 3
						}
					]
				},
				{
					"valueCoding": {
						"code": "10604",
						"display": "Uitstekend"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 4
						}
					]
				}
			],
			"item": [
				{
					"linkId": "10600_helpText",
					"text": "Typisch voedingsprofiel.",
					"_text": {
						"extension": [
							{
								"url": "http://hl7.org/fhir/StructureDefinition/rendering-xhtml",
								"valueString": "Typisch voedingsprofiel.<br/><br/>- <b>Onvoldoende</b>: Eet nooit een volledige maaltijd. Eet zelden meer dan 1/3 van het voedsel dat hem wordt aangeboden. Eet twee porties eiwitten (vlees- of melkproducten) of minder per dag. Neemt vloeistoffen moeizaam in. Neemt geen vloeibaar voedselsupplement OF Krijgt niets per os en/ of wordt gedurende meer dan vijf dagen met dunne vloeistoffen of intraveneus gevoed.<br/><br/>- <b>Waarschijnlijk ontoereikend</b>: Eet zelden een volledige maaltijd en eet over het algemeen slechts 1/2 van het voedsel dat hem wordt aangeboden. De proteïne inname is beperkt tot drie porties vlees- of melkproducten per dag. Neemt af en toe een voedselsupplement OF Krijgt minder dan de optimale hoeveelheid vloeistof / of via sonde toegediend.<br/><br/>- <b>Toereikend</b>: Eet meer dan de helft van de meeste maaltijden. Eet elke dag vier porties proteïne (vlees- of melkproducten). Weigert af en toe een maaltijd, maar neemt gewoonlijk een supplement wanneer dat wordt aangeboden. OF Wordt met sonde gevoed of krijgt speciale voeding: vermoedelijk wordt hierdoor in de meeste behoefte voorzien.<br/><br/>- <b>Uitstekend</b>: Eet het grootste gedeelte van elke maaltijd op. Weigert nooit een maaltijd. Eet meestal 4 of meer porties vlees- en melkproducten per dag. Eet een enkele keer tussen de maaltijden. Heeft geen bijvoeding nodig."
							}
						]
					},
					"type": "display",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "help",
										"display": "Help-Button"
									}
								],
								"text": "Help-Button"
							}
						}
					]
				}
			]
		},
		{
			"linkId": "10700",
			"text": "Wrijving en schuiven",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "horizontal"
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "10701",
						"display": "Probleem"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "10702",
						"display": "Mogelijk probleem"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				},
				{
					"valueCoding": {
						"code": "10703",
						"display": "Geen probleem"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 3
						}
					]
				}
			],
			"item": [
				{
					"linkId": "10700_helpText",
					"text": "",
					"_text": {
						"extension": [
							{
								"url": "http://hl7.org/fhir/StructureDefinition/rendering-xhtml",
								"valueString": "- <b>Probleem</b>: Heeft matige tot volledige hulp nodig om zich te bewegen. Kan niet volledig overeind komen zonder langs de lakens te schuiven. Glijdt in bed of stoel vaak naar beneden, zodat het vaak nodig is hem met volledige hulp terug op de plaats te zetten. Spasticiteit, samentrekkingen of agitatie leiden tot bijna constante wrijving.<br/><br/>- <b>Mogelijk probleem</b>: Beweegt zich lichtjes of heeft minimale hulp nodig. Tijdens het bewegen schuift de huid waarschijnlijk in zekere mate langs de lakens, tegen de stoel of andere toestellen. Behoudt in stoel of bed meestal een relatief goede houding, maar glijdt af en toe naar beneden.<br/><br/>- <b>Geen probleem</b>: Beweegt zich in bed en stoel onafhankelijk en heeft voldoende spierkracht om tijdens een beweging volledig overeind te komen. Behoudt in stoel of bed altijd een goede houding."
							}
						]
					},
					"type": "display",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "help",
										"display": "Help-Button"
									}
								],
								"text": "Help-Button"
							}
						}
					]
				}
			]
		}
	]
}
